module.exports = __webpack_public_path__ + "static/img/service_jiancecailiao.2d6cbf12.png";